module.exports = __webpack_public_path__ + "static/media/eight-pcs-box.e7d529fe.png";